function marketStartTs(market) {
  return new Date(market?.startAt).getTime();
}

function marketEndTs(market) {
  return new Date(market?.endAt).getTime();
}

function hasValidWindow(market) {
  const startTs = marketStartTs(market);
  const endTs = marketEndTs(market);
  return Number.isFinite(startTs) && Number.isFinite(endTs) && startTs < endTs;
}

export function isActiveMarket(market, nowTs = Date.now()) {
  const startTs = marketStartTs(market);
  const endTs = marketEndTs(market);
  return Number.isFinite(startTs) && Number.isFinite(endTs) && startTs <= nowTs && nowTs < endTs;
}

export function isUpcomingMarket(market, nowTs = Date.now()) {
  const startTs = marketStartTs(market);
  const endTs = marketEndTs(market);
  return Number.isFinite(startTs) && Number.isFinite(endTs) && nowTs < startTs && startTs < endTs;
}

export function isClosedMarket(market, nowTs = Date.now()) {
  const endTs = marketEndTs(market);
  return hasValidWindow(market) && endTs <= nowTs;
}

export function classifyMarketsByWindow(markets, nowTs = Date.now()) {
  const active = [];
  const upcoming = [];
  const closed = [];

  for (const market of markets) {
    if (isActiveMarket(market, nowTs)) {
      active.push(market);
      continue;
    }

    if (isUpcomingMarket(market, nowTs)) {
      upcoming.push(market);
      continue;
    }

    if (isClosedMarket(market, nowTs)) {
      closed.push(market);
    }
  }

  active.sort((a, b) => marketEndTs(a) - marketEndTs(b));
  upcoming.sort((a, b) => marketStartTs(a) - marketStartTs(b));
  closed.sort((a, b) => marketEndTs(b) - marketEndTs(a));

  return { active, upcoming, closed };
}
